'use client';

import { useParams } from 'react-router-dom';

import ReportDetailPage from '@/app/reports/[reportId]/page';
import { withRequiredPermission } from '@/components/auth/with-required-permission';
import { PERMISSIONS } from '@/hooks/use-perm';

function ReportDetailPageContainerInner() {
  const { reportId, orgSlug } = useParams();
  if (!reportId) return null;
  return <ReportDetailPage reportId={reportId} accountKey={orgSlug ?? 'default'} />;
}

export const ReportDetailPageContainer = withRequiredPermission(
  ReportDetailPageContainerInner,
  PERMISSIONS.BILLING_VIEW,
);
